import { render, staticRenderFns } from "./B2blocalisation.vue?vue&type=template&id=7fe0e876&scoped=true&"
import script from "./B2blocalisation.vue?vue&type=script&lang=js&"
export * from "./B2blocalisation.vue?vue&type=script&lang=js&"
import style0 from "./B2blocalisation.vue?vue&type=style&index=0&id=7fe0e876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe0e876",
  null
  
)

export default component.exports